<template>
  <div class="calendar-additional pr-2">
    <div class="calendar-additional-header">
      <p class="calendar-additional-month-name">{{ fullMonthName }}</p>
      <p class="calendar-additional-year">{{ currentYear }}</p>
      <div class="calendar-additional-buttons">
        <button 
          @click="$emit('prevMonth')" 
          class="calendar-additional-arrow calendar-additional-arrow-left"
        ><i class="bx bx-chevron-left"></i></button>
        <button
          @click="$emit('nextMonth')"
          class="calendar-additional-arrow calendar-additional-arrow-right"
        ><i class="bx bx-chevron-right"></i></button>
      </div>
    </div>

    <div>
      <div class="calendar-additional-weekdays">
        <div v-for="(dayName, dayIndex) in dayNames"
            :key="dayIndex"
            class="calendar-additional-weekday">
          {{ dayName }}
        </div>
      </div>

      <div class="calendar-additional-days">
        <div v-for="day in LastDaysPrevMonth"
          :key="100 + day" class="calendar-additional-start-day"
        >{{ day }}</div>

        <div
          v-for="currentDay in moment(`${currentYear}-${String(currentMonth + 1).padStart(2, '0')}`).daysInMonth()"
          :key="currentDay"
          :class="['calendar-additional-day', isToday(currentDay) ? 'calendar-additional-current-day' : '']"
          @click="$emit('openWeekWithDay', currentDay, $event)"
        >
          {{ currentDay }}
          <p v-if="sumOfTaskByDay(currentDay) > 0" class="calendar-additional-sum-of-tasks-on-day">{{ sumOfTaskByDay(currentDay) }}</p>
        </div>

        <div v-for="day in FirstDaysNextMonth"
          :key="200 + day" class="calendar-additional-start-day"
        >{{ day }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullMonthName: {
      type: String,
      default: '',
    },
    currentMonth: {
      type: [String, Number],
      default: '',
    },
    currentMonth: {
      type: [String, Number],
      default: '',
    },
    currentYear: {
      type: [String, Number],
      default: '',
    },
    dayNames: {
      type: Array,
      default: () => [],
    },
    LastDaysPrevMonth: {
      type: Array,
      default: () => [],
    },
    FirstDaysNextMonth: {
      type: Array,
      default: () => [],
    },
    filtredTasksByTags: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    isToday(day) {
      return new Date().toLocaleDateString() === new Date(this.currentYear, this.currentMonth, day).toLocaleDateString();
    },
    sumOfTaskByDay(day) {
      let tasks = this.filtredTasksByTags.filter(task => {
        if (task.realization_at) {
          return task.reference_status_id != 403 && task.reference_status_id != 402 && task.realization_at.split(' ')[0] === `${this.currentYear}-${String(this.currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        }
      })
      return tasks.length;
    },
  }
}
</script>